import React from 'react';
import { useTheme } from '../../context/ThemeContext';

const ThemeSwitcher = () => {
  const { theme, toggleTheme, isDark } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className={`relative w-16 h-9 rounded-full transition-all duration-300 flex items-center px-1 ${
        isDark ? 'bg-[#F39C12]' : 'bg-gray-200'
      }`}
      title={isDark ? 'Passer en mode clair' : 'Passer en mode sombre'}
    >
      {/* Cercle qui bouge */}
      <span
        className={`absolute w-7 h-7 rounded-full bg-white shadow-md flex items-center justify-center transition-transform duration-300 ${
          isDark ? 'translate-x-7' : 'translate-x-0'
        }`}
      >
        <span className="text-sm">{isDark ? '🌙' : '☀️'}</span>
      </span>

      {/* Icônes de fond */}
      <span className="absolute left-2 text-xs opacity-50">☀️</span>
      <span className="absolute right-2 text-xs opacity-50">🌙</span>
    </button>
  );
};

export default ThemeSwitcher;